import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Helpers } from '../../../core/src/helpers';
import { fetchPrices, viewPrice } from '../../product-actions';


const ProductPriceWrapper = (Component) => (props) => {
	return (
		<Component {...props} />
	)
}

const mapPriceToProps = (state, ownProps) => {
	const price = Helpers.getProductPrice(ownProps.product, state.productData.productInfo.productPrices);
	//include user profile data since it can relate to price info
	let { userData: { profileData: { personData } } } = state;
	return {
		price,
		personData
	};
}

const mapStateToProps = (state, ownProps) => {
	try {
		return {
			prices: state.productData.productInfo.productPrices
		};
	} catch (e) { }

	return {
		prices: {}
	};
};

const mapDispatchToProps = dispatch => {
	return {
		fetchPrices: Helpers.memoize((ids) => dispatch(fetchPrices(ids))),
		viewPrice: (sku) => dispatch(viewPrice(sku))
	};
};


/**
 * Use withProductPrice when you need the price for an individual sku
 * @type {[type]}
 */
export const withProductPrice = compose(connect(mapPriceToProps, mapDispatchToProps), ProductPriceWrapper);

/**
 * Use withPrices when you need prices for several skus at once
 * @type {[type]}
 */
const withPrices = compose(connect(mapStateToProps, mapDispatchToProps), ProductPriceWrapper);

const selectPrices = Helpers.memoize((prices, products) => {
	return products.reduce((r, p) => {
		r[p.sku] = Helpers.getProductPrice(p, prices);
		return r;
	}, {});
}, (prices, products) => {
	return products.reduce((r, p) => {
		return r.concat(`${p.sku}-${p.sku in prices}`)
	}, ``)
})

/**
 * 
 */
export const PriceContainer = withPrices(({ products = [], fetchPrices, prices, children }) => {
	useEffect(() => {
		let noPrice = products.filter(({ sku, itemId }) => {
			const priceFailure = prices[itemId];
			//when prices fai to fetch, we get no response back so we dont know the sku
			// which mean we need to check for fetch fail by itemId
			return !(sku in prices) && (!priceFailure || !priceFailure.priceFetchFailed)
		});
		if (noPrice.length > 0) {
			fetchPrices(noPrice.map(p => p.itemId));
		}
	})
	return children({ prices: selectPrices(prices, products) });
});

export default withPrices;
